import React, { useEffect, useState, useRef } from 'react';
import { Container } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useTranslation } from 'react-i18next';
import { cloneDeep } from 'lodash';
import * as careLabelAction from './store/CARELABEL.action';
import Loader from '../../../Components/Utility/Loader/Loader';
import ProductCareImport from './ProductCareImport';
import './ProductCareLabel.css';
import '../Testing/Testing.css';
import CareInstructionTable from './tables/CareInstructionTable';
import noImage from '../../../assets/images/no-image.png';
import ProductImageThumb from '../../../Components/ProductImageThumb';
import ConfirmationPopup from '../../../Components/ModalPopup/ConfirmationPopup';
import CareComments from './CareComments';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';
import CareLayout from './tables/CareLayout';
import { useProductEditNavigation } from '../../../hooks/useProductEditNavigation';
import { useCareInstructionState } from './CareLabelProvider/CareUserInstructionStateProvider';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';
import { shortenandHoverString } from '../../../Components/helper';
import Chat from '../../Chat/Chat';

function CareInstructionList() {
  const params = useParams();
  const careType = params?.careType;
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const devOrderId = params?.devOrderId;
  const { CareLabelstate, setCareLabelState, handleAddCareLabel, userState, setUserState } = useCareInstructionState();
  const { goToProductEdit } = useProductEditNavigation();
  const reducerState = useSelector((redState) => redState);
  const {
    CareLabelProductReducer: { comment, commentSwitch, isComplete, careList, isVisibleToSupplier },
    UserDetails: { isSupplierLoggedIn, userInfo },
    BOMConfigDetails: { productDetails },
    UserInstructionDetails,
    Users,
  } = reducerState;
  const { logInRights } = Users;
  const { CareLabelList } = CareLabelstate;
  const [state, setState] = useState({
    deletedId: [],
    deleteModal: false,
    deleteMultipleModal: false,
    loader: false,
    isProductArchive: false,
  });
  const { deletedId, deleteModal, deleteMultipleModal } = state;
  const { CheckActionPermission } = useComponent();
  const ProductAddEditAccess = CheckActionPermission(logInRights, 'products', 'addProduct', 'addEdit');
  const CareAddEditAccess = CheckActionPermission(logInRights, 'products', 'care', 'addEdit');
  const CareDeleteAccess = CheckActionPermission(logInRights, 'products', 'care', 'delete');
  const CareApproveRejectAccess = CheckActionPermission(logInRights, 'products', 'care', 'approveReject');
  const { tabData } = UserInstructionDetails;
  const expandSearchRef = useRef(null);
  const careLayout = 'Care Label Layout';
  const findIndex = CareLabelList?.findIndex((ele) => ele?.tabId?.toString() === userState?.tabId?.toString());

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      isProductArchive: productDetails?.isArchived,
    }));
  }, [productDetails]);

  useEffect(() => {
    setCareLabelState((prev) => ({
      ...prev,
      comment,
      commentSwitch,
      loader: false,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [comment, commentSwitch]);

  useEffect(() => {
    setCareLabelState((prev) => ({
      ...prev,
      searchText: '',
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [careType]);

  useEffect(() => {
    setCareLabelState((prev) => ({
      ...prev,
      isComplete,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isComplete]);

  const addCareLabelComments = (data) => {
    setCareLabelState((prev) => ({
      ...prev,
      comment: data,
    }));
  };

  const addUpdateOrderPermission = async (_e, val, toggle) => {
    const reqObj = {
      type: 'care-label',
      devOrderId,
    };
    const isVisibleToSupplier = {};
    CareLabelList.map((tab) => {
      isVisibleToSupplier[tab.tabId] = tab.isToggleSwitch;
      return { ...isVisibleToSupplier };
    });
    isVisibleToSupplier.comment = val !== undefined ? val : CareLabelstate?.commentSwitch;
    const payload = {
      comment: CareLabelstate?.comment,
      isVisibleToSupplier,
    };
    if (toggle) {
      payload.comment = comment;
      await dispatch(careLabelAction.saveOrderPermission(reqObj, payload, 'switch', t));
    } else {
      await dispatch(careLabelAction.saveOrderPermission(reqObj, payload, '', t));
      await dispatch(careLabelAction.fetchOrderPermission(reqObj));
    }
  };

  const handleCustomSwitchCases = (e) => {
    const value = e.target.checked;
    setCareLabelState((prev) => ({
      ...prev,
      commentSwitch: e.target.checked,
    }));

    addUpdateOrderPermission('', value, 'switch');
  };

  const updateMarkCompleteStatus = async (val) => {
    const reqObj = {
      type: 'mark-complete',
      devOrderId,
    };
    const res = await dispatch(careLabelAction.saveMarkCompleted(reqObj, val, t));
    if (res.code === 400) {
      setCareLabelState((prev) => ({
        ...prev,
        isComplete: false,
      }));
    }
  };

  const handleIsCompleteChange = (e) => {
    setCareLabelState((prev) => ({
      ...prev,
      isComplete: e.target.checked,
    }));
    updateMarkCompleteStatus(e.target.checked);
  };
  const updateswitchToggle = async (switchData) => {
    const reqObj = {
      type: 'care-label',
      devOrderId,
    };
    const isVisibleToSupplier = {};
    switchData.map((tab) => {
      isVisibleToSupplier[tab.tabId] = tab.isToggleSwitch;
      return { ...isVisibleToSupplier };
    });
    const payload = {
      comment: CareLabelstate?.comment,
      isVisibleToSupplier,
    };
    await dispatch(careLabelAction.saveOrderPermission(reqObj, payload, 'switch', t));
  };
  const handleTabSwitch = async (e, id) => {
    e.preventDefault();
    const tabSwitch = cloneDeep(CareLabelList);

    const switchData = tabSwitch.map((tab) => {
      if (tab.tabId === e.target.name) {
        return { ...tab, isToggleSwitch: e.target.checked };
      }
      return { ...tab, isToggleSwitch: isVisibleToSupplier[tab.tabId] || false };
    });

    setCareLabelState((prev) => ({
      ...prev,
      CareLabelList: switchData,
    }));
    setUserState((prevState) => ({
      ...prevState,
      tabId: id,
    }));
    await updateswitchToggle(switchData);
  };

  const handleData = (id, forDocument) => {
    const tabDetailsData = CareLabelList?.[findIndex]?.tabDetails?.filter((ele) => ele.rowId && ele?._id) || [];

    // Update CareLabelList with filtered tabDetails for the current tab
    if (findIndex !== -1 && CareLabelList?.[findIndex]) {
      const updatedCareLabelList = [...CareLabelList];
      updatedCareLabelList[findIndex] = {
        ...updatedCareLabelList[findIndex],
        tabDetails: tabDetailsData,
      };

      setCareLabelState((prev) => ({
        ...prev,
        CareLabelList: updatedCareLabelList,
      }));
    }

    setUserState((prevState) => ({
      ...prevState,
      tabId: id,
      tabData,
      addNewRow: false,
      showCareLayout: forDocument,
    }));
  };

  const handleCloseDeleteModal = () => {
    setState((prevState) => ({
      ...prevState,
      deletedId: [],
      deleteModal: false,
      deleteMultipleModal: false,
    }));
    setUserState((prevState) => ({
      ...prevState,
      selectedIdArray: [],
    }));
  };

  const confirmDelete = async () => {
    const payload = {
      rowId: deletedId.length > 0 ? deletedId : userState?.selectedIdArray,
      devOrderId,
      tabId: userState?.tabId,
    };
    const response = await dispatch(careLabelAction.deleteCareInstruction(payload, t));
    if (response.code === 200) {
      const paramsData = {
        devOrderId,
      };
      await dispatch(careLabelAction.fetchCareInstructionProduct(paramsData));
      handleCloseDeleteModal();
      setCareLabelState((prevState) => ({
        ...prevState,
        selectedLibrary: [],
      }));
    }
  };

  const handleDeleteMultiple = (row) => {
    const arr = [];
    if (row) arr.push(row);
    setState((prevState) => ({
      ...prevState,
      deleteMultipleModal: true,
      deletedId: arr,
    }));
    setUserState((prev) => ({
      ...prev,
      isSelectAll: false,
    }));
  };

  const mainRendering = () => {
    return (
      <div>
        <ProductCareImport
          handleDeleteMultiple={handleDeleteMultiple}
          handleAddCareLabel={handleAddCareLabel}
          CareAddEditAccess={CareAddEditAccess}
          CareDeleteAccess={CareDeleteAccess}
          isProductArchived={state?.isProductArchive}
        />
      </div>
    );
  };

  const handleSearch = (input) => {
    setCareLabelState((prev) => ({
      ...prev,
      searchText: input,
    }));
  };

  useEffect(() => {
    if (CareLabelstate?.searchText) {
      // Create a deep copy of the CareLabelList to avoid mutating the original state
      const updatedList = JSON.parse(JSON.stringify(careList?.tabs));

      // Only filter the tabDetails of the current tab
      if (updatedList[findIndex]?.tabDetails) {
        const matchedRowIds = updatedList[findIndex].tabDetails
          .filter((item) => typeof item?.value === 'string' && item?.value?.toLowerCase().includes(CareLabelstate?.searchText?.toLowerCase()))
          .map((item) => item?.rowId);
        console.log(
          '🚀 ~ useEffect ~ matchedRowIds:',
          updatedList[findIndex].tabDetails.filter((item) => console.log('itemssssss', item?.value)),
        );

        // Step 2: Keep all tabDetails that share any of the matched rowIds
        updatedList[findIndex].tabDetails = updatedList[findIndex]?.tabDetails?.filter((item) => matchedRowIds.includes(item.rowId));
      }
      console.log('🚀 ~ useEffect ~ updatedList[findIndex]:', updatedList[findIndex]);

      setCareLabelState((prev) => ({
        ...prev,
        CareLabelList: updatedList,
      }));
    } else {
      // When search is cleared, reset to the original list
      setCareLabelState((prev) => ({
        ...prev,
        CareLabelList: careList?.tabs,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [CareLabelstate?.searchText]);

  const handleEditProductDetails = () => {
    goToProductEdit(devOrderId);
  };

  useEffect(() => {
    // This function will be called when the component is unmounted
    return () => {
      dispatch(careLabelAction.clearCareLabelReducer());
    };
  }, [dispatch]);
  const handleIconClick = () => {
    // Add a class to the input on icon click
    expandSearchRef.current.classList.toggle('active-input');
  };

  const imageData = (option) => {
    return option?.image || noImage;
  };

  const handleRefresh = async () => {
    const res = await dispatch(careLabelAction.refreshTabs(devOrderId, t));
    if (res) {
      await dispatch(careLabelAction.fetchCareInstructionProduct({ devOrderId }));
    }
  };

  useEffect(() => {
    const fetchCareLayout = async () => {
      if (userState?.showCareLayout) {
        await dispatch(careLabelAction.fetchCareLabelLayout(devOrderId));
      }
    };
    fetchCareLayout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userState?.showCareLayout]);

  /**
   * Persists the Care/User instruction comment, resending the current supplier-visibility
   * switches because the order-permission endpoint replaces that map as a whole.
   * @param {string} updatedComment - Editor content to save.
   * @returns {Promise<boolean>} True when the comment was saved.
   */
  const handleCommentAutoSave = async (updatedComment) => {
    const reqObj = { type: 'care-label', devOrderId };
    const visibilityMap = { comment: CareLabelstate?.commentSwitch };
    CareLabelList?.forEach((tab) => {
      visibilityMap[tab.tabId] = tab.isToggleSwitch;
    });
    const payload = { comment: updatedComment, isVisibleToSupplier: visibilityMap };
    const isSaved = await dispatch(careLabelAction.saveOrderPermission(reqObj, payload, '', t));
    if (isSaved) {
      await dispatch(careLabelAction.fetchOrderPermission(reqObj));
    }
    return isSaved;
  };

  return (
    <div>
      {CareLabelstate?.initialLoader ? (
        <Loader />
      ) : (
        <>
          <div className="page-title-filter sticky">
            <div className="title-container">
              <ProductImageThumb src={imageData(CareLabelstate?.devOrderData)} alt={CareLabelstate?.devOrderData?.number} />

              <h4 className="title ml-3 edit-product-icon">
                {t('TAKING_DATES.CARE_LABELS')}
                {CareLabelstate?.devOrderData?.number ? <>&nbsp;|&nbsp;{shortenandHoverString(CareLabelstate?.devOrderData?.number, 15)}</> : null}
                {CareLabelstate?.devOrderData?.description ? <>&nbsp;|&nbsp;{shortenandHoverString(CareLabelstate?.devOrderData?.description, 40)}</> : null}
              </h4>
              {!isSupplierLoggedIn && ProductAddEditAccess && !productDetails?.isArchived && (
                <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.EDIT')}>
                  <button
                    aria-label="edit"
                    type="button"
                    className="btn edit-product-icon d-inline-flex"
                    onClick={handleEditProductDetails}
                    disabled={state?.isProductArchive}
                  >
                    <i className="icon-Edit-1 text-grey-color f-24" />
                  </button>
                </CustomTooltip>
              )}
            </div>
            <div className="search-filter  action-icons-container care-library-filter">
              {userState?.tabName !== careLayout && (
                <div ref={expandSearchRef} className="common-expand-search">
                  <button type="button" onClick={handleIconClick} className="btn btn-toggle">
                    <span className="sr-only">Search</span>
                    <span className="icon-Magnifying-Glass-Solid" />
                  </button>
                  <input
                    name="search"
                    type="text"
                    onChange={(e) => handleSearch(e.target.value)}
                    placeholder={t('PRODUCTS.CARE_LABEL.SEARCH')}
                    disabled={state?.isProductArchive}
                  />
                </div>
                // <SearchBar onSearch={(e) => handleSearch(e.target.value)} value={CareLabelstate?.searchText} placeholder={`Search care Label ${careType}...`} />
              )}
              <div className="floting-actions">
                {!isSupplierLoggedIn && CareAddEditAccess && (
                  <CustomTooltip placement="top" tooltipText={t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.REFRESH')}>
                    <button
                      type="button"
                      aria-label={t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.REFRESH')}
                      onClick={handleRefresh}
                      className="btn"
                      disabled={state?.isProductArchive}
                    >
                      <i className="icon-Replace" />
                    </button>
                  </CustomTooltip>
                )}
              </div>
            </div>
          </div>
          <CareComments
            handleCustomSwitchCases={handleCustomSwitchCases}
            handleIsCompleteChange={handleIsCompleteChange}
            addCareLabelComments={addCareLabelComments}
            handleCommentAutoSave={handleCommentAutoSave}
            handleTabSwitch={handleTabSwitch}
            CareAddEditAccess={CareAddEditAccess}
            handleData={handleData}
            isProductArchived={state?.isProductArchive}
          />
          <Container className="product-care-list-container" fluid>
            {!userState?.showCareLayout && !isSupplierLoggedIn && mainRendering()}
            {userState?.tabId && !userState?.showCareLayout && (
              <CareInstructionTable
                isSupplierLoggedIn={isSupplierLoggedIn}
                handleDeleteMultiple={handleDeleteMultiple}
                CareAddEditAccess={CareAddEditAccess}
                CareDeleteAccess={CareDeleteAccess}
                isProductArchived={state?.isProductArchive}
              />
            )}

            {userState?.showCareLayout && userState?.tabId && (
              <CareLayout
                devOrderId={devOrderId}
                isSupplierLoggedIn={isSupplierLoggedIn}
                CareApproveRejectAccess={CareApproveRejectAccess}
                CareAddEditAccess={CareAddEditAccess}
                CareDeleteAccess={CareDeleteAccess}
                isProductArchived={state?.isProductArchive}
              />
            )}
          </Container>
          {deleteModal && (
            <ConfirmationPopup
              onOpen={deleteModal}
              onConfirm={confirmDelete}
              title={t('CARE-DESCRIPTION.DELETE_SINGLE_CONFIRMATION_TITLE', { careType: CareLabelstate?.activeCareType })}
              message={t('CARE-DESCRIPTION.DELETE_SINGLE_CONFIRMATION_MESSAGE')}
              toggle={() => handleCloseDeleteModal()}
            />
          )}
          {deleteMultipleModal && (
            <ConfirmationPopup
              onOpen={deleteMultipleModal}
              onConfirm={() => confirmDelete()}
              title={t('CARE-DESCRIPTION.DELETE_MULTIPLE_CONFIRMATION_TITLE')}
              message={t('CARE-DESCRIPTION.DELETE_MULTIPLE_CONFIRMATION_MESSAGE')}
              toggle={() => handleCloseDeleteModal()}
            />
          )}

          {productDetails && <Chat moduleKey="CARE_USER_INSTRUCTION" moduleList={[]} currentUser={userInfo} paddingBottom={userState?.showCareLayout} />}
        </>
      )}
    </div>
  );
}

export default CareInstructionList;
